import React, { useState } from "react";
import Modal from "react-modal";
import { Create_Api } from "../ApiUrls";
import { toast } from "react-toastify";


const EnquiryModel = ({ isOpen, onClose,selectedProperty }) => {

    const [IsUploading, setIsUploading] = useState(false);
    const [Email, setEmail] = useState('');
    const [Number, setNumber] = useState('');

    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isValidPhoneNumber = (number) => /^[6-9]\d{9}$/.test(number);

    const SendContactUs = async () => {
        if (!Email.trim() || !isValidEmail(Email)) return toast.error('Enter a valid email address!');
        if (!Number.trim() || !isValidPhoneNumber(Number)) return toast.error('Enter a valid 10-digit mobile number!');

        try {
            let data = {
                Property:selectedProperty,
                Email,
                Number,
            }
            setIsUploading(true)
            const response = await Create_Api(`api/admin/CreatePropertyenquiry`, data)
            toast.success(response?.message);
            setEmail('')
            setNumber('')
            onClose();
            setIsUploading(false)
        } catch (error) {
            setIsUploading(false)
            toast.error(error?.response?.data?.message);
            console.log(error)
        }
    }


    return (
        <Modal isOpen={isOpen} onRequestClose={onClose} className="modal" overlayClassName="modaloverlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>Contact Info</h2>
                    <button className="close-button" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <br/>
                <div className="contact-form">
                    <div className="input-field">
                        <label>Email</label>
                        <input
                            type="email"
                            placeholder="Enter Address"
                            value={Email}
                            onChange={(e) => { setEmail(e.target.value) }}
                        />
                    </div>
                    <div className="input-field">
                        <label>Number</label>
                        <input
                            type="number"
                            placeholder="Enter Number"
                            value={Number}
                            onChange={(e) => { setNumber(e.target.value) }}
                        />
                    </div>
                    <button className="submit-button" onClick={() => { SendContactUs() }}>{IsUploading ? "Please Wait" : "Send"}</button>
                </div>
            </div>
        </Modal>
    );
};

export default EnquiryModel;
